module.exports = __webpack_public_path__ + "2f42a263a33c1969af839e53cd56ad40.png";